import React from 'react'

export const LoadingResult: React.FC = () => {
  return (
    <div className='d-flex px-4 py-3'>
      <div className='skeleton w-100 loading-result-skeleton' style={{ height: '24px' }} />
    </div>
  )
}
